import React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";

const OpenModalButton = styled(motion.button)<{ mainButton?: boolean }>`
  font-size: ${(props) => (props.mainButton ? "3rem" : "1.2rem")};
  padding: ${(props) => (props.mainButton ? "30px" : "20px")};
  border-radius: 50%;
  border: none;
  background-color: #e00003;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
  width: ${(props) => (props.mainButton ? "6.5rem" : "4.5rem")};
  height: ${(props) => (props.mainButton ? "6.5rem" : "4.5rem")};
  box-shadow: ${(props) => (props.mainButton ? "0 0 0 0 rgba(255, 77, 79, 0.7)" : "none")};
  animation: ${(props) => (props.mainButton ? "pulse 2.8s infinite" : "none")};
`;

interface AnimatedOpenButtonProps {
  children: React.ReactNode;
  handleClick: () => void;
  mainButton?: boolean;
}

const AnimatedOpenButton: React.FC<AnimatedOpenButtonProps> = ({ children, handleClick, mainButton }) => {
  return (
    <OpenModalButton
      onClick={handleClick}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
      mainButton={mainButton}
    >
      {children}
    </OpenModalButton>
  );
};

export default AnimatedOpenButton;
